import { useCallback, useState } from 'react';

// Local draft state mirrored into a table-owned ref, so a save handler in a
// sibling cell can read it without the table re-rendering per keystroke.
export function useDraftValue(draftRef: React.MutableRefObject<string>) {
    const [value, setValueState] = useState(() => draftRef.current);
    const setValue = useCallback((v: string) => {
        draftRef.current = v;
        setValueState(v);
    }, [draftRef]);
    return [value, setValue] as const;
}
